<template>
    <div>
        <h1>Verify</h1>
        <p>Oh, well done! Now it is time to verify your API!</p>
        <p>Although you should have full coverage unit tests by now, nothing beats an external test suite written by someone else. Right?</p>
        <p>Please supply your base path to your API, e.g. typically <i>http://localhost:8080</i></p>
        <dm-input name="basePath" v-model="basePath"></dm-input>
        <p><b>Please note</b> that you most likely need to enable <a href="https://en.wikipedia.org/wiki/Cross-origin_resource_sharing" target="_blank">CORS</a> in your REST controller, since this test is not performed from the same host as your API is hosted. Allowing the origin <i>*</i> will allow all hosts, which is the best option in this case (but in general not recommended on public websites). Hint: there is an <i>@CrossOrigin</i> annotation.</p>
        <p>If the backend / browser starts to complain about <a href="https://www.owasp.org/index.php/Cross-Site_Request_Forgery_(CSRF)">CSRF</a>-things, then you might want to do som hacking and extend <i>WebSecurityConfigurerAdapter</i>. 
        <p>Ready?</p>
        <dm-button v-on:click="runMyTests()" color="black" v-if="log.length == 0">Run tests</dm-button>
        <dm-button v-on:click="runMyTests()" color="black" v-else>Re-run tests</dm-button>

        <h3 v-if="log.length > 0">Test results:</h3>

        <table>
            <tr v-for="test in log" v-bind:key="test.name">
                <th>{{test.name}}<span class="error" v-if="test.response.notes != ''">{{test.response.notes}}</span></th>
                <td><dm-badge :color="getColor(test)" size="mini">{{getLabel(test)}}</dm-badge></td>
            </tr>
        </table>
        <br /><br />
        <LinkBox>
            <li><router-link to="/verify">???</router-link></li>
        </LinkBox>
    </div>
</template>

<script>
import LinkBox from '@/components/LinkBox.vue'
import { executeTests } from '@/utils/verify-utils'
import tests from '@/utils/verify-tests'



export default {
    name: 'BackendJava',
    components: {
        LinkBox
    },
    data() {
        return {
            debug: {},
            log: [],
            basePath: "http://localhost:8080"
        }
    },
    methods: {
        runMyTests() {
            this.log = executeTests(this.basePath, tests);
        },
        getColor(test) {
            if(test.aborted) {
                return "orange";
            }
            if(test.pending) {
                return "white";
            }
            if(test.response.success) {
                return "green";
            }
            return "red";
        },
        getLabel(test) {
            if(test.aborted) {
                return "Aborted";
            }
            if(test.pending) {
                return "Pending";
            }
            if(test.response.success) {
                return "OK";
            }
            return "Error";
        }
    }
}
</script>

<style scoped>
.instructions li {
    margin-bottom:10px;
}
table {
    width:100%;
}
td {
    margin: 0;
    padding: 3px;
    text-align: right;
}
th {
    font-weight: normal;
}
.error {
    display: block;
    color: #FF0000;
    padding-left: 10px;
}
</style>
